module.exports = __webpack_public_path__ + "static/media/heartDisease.e17259eb.mp3";